import React, { lazy } from 'react'
import { SuspenseLoader } from '../../Web/WebLoader'

const LazyIconSvg = lazy(() =>
  import('./IconComponent' /* webpackChunkName: "svg-icons" */).then((val) => ({ default: val.IconSvg }))
)

export const IconSvg = (props) => (
  <SuspenseLoader>
    <LazyIconSvg {...props} />
  </SuspenseLoader>
)
